import React from 'react';

import { Container } from './styles';

const RequiredFieldInformation: React.FC = () => {
  return <Container>*</Container>;
};

export default RequiredFieldInformation;
